module.exports = __webpack_public_path__ + "static/team1-e9c199c332c01f0a309233cadd854c46.png";